// import Swiper from '../vendor/swiper.js';

// const newSlider = new Swiper('.newSlider', {
//   slidesPerView: 4,
//   spaceBetween: 40,
//   slidesPerGroup: 1,
//   loop: true,
//   loopFillGroupWithBlank: true,
//   direction: 'horizontal',
//   breakpoints: {
//     0: {
//       slidesPerView: 1,
//       spaceBetween: 0,
//     },
//     768: {
//       slidesPerView: 2,
//       spaceBetween: 30,
//     },
//     1200: {
//       slidesPerView: 4,
//       spaceBetween: 40,
//     },
//   },

//   navigation: {
//     nextEl: '.coaches__slider-button--next',
//     prevEl: '.coaches__slider-button--prev',
//   },
// });
